import { render, staticRenderFns } from "./FormCustomerGroup.vue?vue&type=template&id=0f2e6d56&"
import script from "./FormCustomerGroup.vue?vue&type=script&lang=js&"
export * from "./FormCustomerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports